import fetch from '@/utils/fetch';

export function dictCreate(params){

    return fetch({
         url:'ManageSystem/ManageSystem/saveDataDictionary',
         method:"post",
         data:params
    })

}

export function getDistTree(params){

    return fetch({
         url:'ManageSystem/ManageSystem/getDataDictionaryTree',
         method:"post",
         data:params
    })

}

export function dictRemove(params){

    return fetch({
         url:'ManageSystem/ManageSystem/delDataDictionary',
         method:"post",
         data:params
    })

}

export function dicSeek(params){
    return fetch({
         url:'ManageSystem/ManageSystem/getDataDictionaryDTOs',
         method:"post",
         data:params
    })
}

export function treeSeek(query) {   // 获取详情
    return fetch({
        url: '/ManageSystem/ManageSystem/getDataDictionaryTree',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/pgMent/dictMent.js